<div class="inner-page-header">
  <h3>إستخراج البيانات</h3>
</div>
<div class="request-control">
  <div class="right-side">
    @if (filterData) {
    <app-filter
      [filterData]="filterData"
      [filterDataInit]="filterDataInit"
      [filterPage]="filterPage"
      (formValus)="filterFormValues($event)"
    >
    </app-filter>
    }
  </div>
  <div class="left-side">
    <button class="btn btn-add" (click)="exportFinanceSheet()">
      إستخراج البيانات
    </button>
  </div>
</div>
<!-- request table -->
@if (orders.length > 0) {
<div class="request-table">
  <ayen-selected-count
    [itemsPerPage]="currentItemsPerPage"
    [selectedRows]="selectedRowsPK"
    [totalRowsSelected]="isTotalRowsSelected"
    [pageTitle]="pageTitle"
    [totalItems]="config.totalItems"
    (setTotalRowsSelected)="selectTotalRows($event)"
  >
  </ayen-selected-count>
  <div class="table-responsive">
    <ayen-table
      [tableData]="orderData"
      [paginationConfig]="config"
      (checkedRow)="getSelectedRow($event)"
      [pageUrl]="'/pages/orders/'"
      [boolenObject]="boolenObject"
      class="first-col-fixed"
    >
    </ayen-table>
  </div>
</div>
} @if (orders && orders.length > 0) {
<ayen-pagination
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [totalCount]="config.totalItems"
  [pageTitle]="pageTitle"
  [itemsPerPage]="config.itemsPerPage"
  (pageChange)="changeToSpecific($event)"
  [currentPage]="config.currentPage"
>
</ayen-pagination>
}
